module.exports = __webpack_public_path__ + "static/media/logoMobile.a39a1827.svg";